import { get, post, patch, del } from './client.js';

export const list      = ()                           => get('/platform/roles');
export const getOne    = (id)                         => get(`/platform/roles/${id}`);
export const create    = (name, description, perms)  => post('/platform/roles', { name, description, permissions: perms });
export const update    = (id, body)                   => patch(`/platform/roles/${id}`, body);
export const duplicate = (id)                         => post(`/platform/roles/${id}/duplicate`);
export const remove    = (id)                         => del(`/platform/roles/${id}`);
